export const STORAGE_KEYS = {
  DONOR_RETURN_URL: 'donor_return_url',
  USER_INFO: 'user',
  MOCK_DATA_VERSION: 'mockDataVersion',
  LOCATION_PERMISSION: 'donation_location_perm'
} as const;
